'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

function EmailCTA({ showLoading, subscribed }) {
  const attrs = {
    type: 'submit',
    'data-bhc': 'input:submit',
  };

  if (subscribed) {
    attrs.disabled = 'disabled';
  }

  if (showLoading) {
    return h('button.button.btn.btn-invert.loading', attrs, '');
  }

  const locale = `js.modules.email_subscription.${
    subscribed ? 'Subscribed' : 'Subscribe'
  }`;

  return h(
    Translate,
    {
      tag: 'button',
      attrs: {
        class: `button btn btn-invert`,
        ...attrs,
      },
    },
    locale
  );
}

module.exports = EmailCTA;
